import { Tab, TabList, Tabs } from '@carbon/react';
import { useHistory, useLocation } from 'react-router-dom';

const selectedIndex = (pathname: string) => {
  if (pathname.includes('documents')) return 0;
  if (pathname.includes('wells')) return 1;
  return 0;
};

const SearchTabs = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  return (
    <Tabs
      selectedIndex={selectedIndex(pathname)}
      onChange={({ selectedIndex }) => {
        if (selectedIndex === 0) {
          history.push('/documents');
          return;
        }
        if (selectedIndex === 1) {
          history.push('/wells');
          return;
        }
      }}
    >
      <TabList contained>
        <Tab id="tab-documents">Documents</Tab>
        <Tab id="tab-wells">Wells</Tab>
      </TabList>
    </Tabs>
  );
};

export { SearchTabs };
